<footer>
    <div class="content">
        <img src="../../assets/logo.svg" />
        <ul>
            <li>Início</li>
            <li>Avaliações</li>
            <li>Assinatura</li>
            <li>FAQ</li>
            <li>Contato</li>
        </ul>

    </div>
    <div class="footer-text">
        <p>© <span>{{year}} Forecast</span>, Todos os direitos reservados.</p>
    </div>
</footer>